import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e4fd39cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-review container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "user-review__background" }, null, -1))
const _hoisted_3 = { class: "user-review__avatars" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "billing-data__title" }, "Over 1 million people love Shortform!", -1))
const _hoisted_6 = { class: "user-review__buttons" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "user-review__button-icon iconfont ifaq" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "user-review__button-icon iconfont ifaq" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "user-review__item-header" }
const _hoisted_12 = { class: "user-review__item-stars" }
const _hoisted_13 = { class: "user-review__item-date" }
const _hoisted_14 = { class: "user-review__item-text" }
const _hoisted_15 = { class: "user-review__item-footer" }
const _hoisted_16 = { class: "user-review__item-name" }

import { onMounted, onUnmounted, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'UserReview',
  setup(__props) {

const items = [
  {
    date: 'February 4, 2025',
    text: 'Shortform is a great tool to easily access litterature and information in general on topics that affect society and human curiosity on a whole. The summations are easily digestible and I really like how different perspectives from experts are shared on topics while you are reading.',
    name: 'Daniel F.',
  },
  {
    date: 'May 12, 2024',
    text: 'I’ve tried many book summary apps, but Shortform stands out as the best. The summaries go beyond just condensing content—they provide deeper insights, key takeaways, and even comparisons with other books, which helps me truly understand the concepts rather than just skim through them.',
    name: 'Teera Patsri',
  },
  {
    date: 'January 29, 2024',
    text: 'I appreciate that I can read AND listen to the Shortform books. At times I need both, so it is useful. I like that I can adjust the speed while listening. The titles are varied and interesting. Easy to navigate.',
    name: 'Gala P.',
  },
  {
    date: 'November 19, 2024',
    text: 'The one page and book summaries are superb, the support staff is very helpful in a timely way and the site is easy to navigate and there are lots of book summaries at Shortform.',
    name: 'Sandra Bartman',
  },
  {
    date: 'February 22, 2025',
    text: "Your book summaries strike the perfect balance between brevity and thoroughness. I like that you offer insights from other books or experts. I also like that you pose questions for reflection that enable me to implement what I've learned.",
    name: 'Steven G',
  },
  {
    date: 'March 27, 2024',
    text: "Completely transformed my daily walks! I used to just listen to music on my daily walks (which has its place) but now I've started using Shortform's audio feature, and can get exercise for my mind along with my body.",
    name: 'David D.',
  },
]

function avatarImage(index: number): string {
  return require(`@/assets.app/images/billing/user-review-${index}.jpeg`)
}

const container = ref<HTMLElement | null>(null)
const userInteracted = ref(false)

const handleScroll = (
  direction: 'left' | 'right',
  updateUserInteracted = true,
): void => {
  if (!container.value) {
    return
  }

  if (!userInteracted.value) {
    if (updateUserInteracted) {
      userInteracted.value = true
    }
    if (interval) {
      clearInterval(interval)
    }
  }

  const scrollWidth = 312 + 16 // Card width + gap
  const scrollAmount = scrollWidth * (direction === 'left' ? -1 : 1)
  container.value.scrollBy({
    left: scrollAmount,
    behavior: 'smooth',
  })
}

let interval: number | undefined = undefined

onMounted(() => {
  let scrollCount = 0
  interval = setInterval(() => {
    if (!userInteracted.value && scrollCount < items.length) {
      handleScroll('right', false)
      scrollCount++
    } else {
      if (interval) {
        clearInterval(interval)
      }
    }
  }, 10000)
})

onUnmounted(() => {
  if (interval) {
    clearInterval(interval)
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("span", _hoisted_3, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
        return _createElementVNode("img", {
          key: i,
          src: avatarImage(i),
          alt: "",
          class: "user-review__avatar"
        }, null, 8, _hoisted_4)
      }), 64))
    ]),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("button", {
        class: "user-review__button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (handleScroll('left')))
      }, _hoisted_8),
      _createElementVNode("button", {
        class: "user-review__button user-review__button--right",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (handleScroll('right')))
      }, _hoisted_10)
    ]),
    _createElementVNode("div", {
      ref_key: "container",
      ref: container,
      class: "user-review__content"
    }, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(items, (item) => {
        return _createElementVNode("div", {
          key: item.name,
          class: "user-review__item"
        }, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
                return _createElementVNode("span", {
                  key: i,
                  class: "user-review__item-star iconfont ifavorite"
                })
              }), 64))
            ]),
            _createElementVNode("div", _hoisted_13, _toDisplayString(item.date), 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("p", null, "\"" + _toDisplayString(item.text) + "\"", 1)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, _toDisplayString(item.name), 1)
          ])
        ])
      }), 64))
    ], 512)
  ]))
}
}

})